import React, { useMemo, useState } from "react";
import { Button, MultiColumnList, Select, TextField, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useTitleImportEvents } from "../../hooks/useTitleImportEvents";
import styles from "./titleImport.module.css";
var PAGE_SIZE = 50;
export var TitleImportEventsTable = function (_a) {
    var _b, _c;
    var fileName = _a.fileName, isRunning = _a.isRunning, initialErrorCount = _a.initialErrorCount, initialWarningCount = _a.initialWarningCount;
    var formatMessage = useIntl().formatMessage;
    var _d = useState(initialErrorCount > 0 ? "ERROR" : "WARNING"), severity = _d[0], setSeverity = _d[1];
    var _e = useState(""), queryInput = _e[0], setQueryInput = _e[1];
    var _f = useState(""), appliedQuery = _f[0], setAppliedQuery = _f[1];
    var _g = useState(0), offset = _g[0], setOffset = _g[1];
    var page = Math.floor(offset / PAGE_SIZE);
    var _h = useTitleImportEvents({
        fileName: fileName,
        severity: severity,
        query: appliedQuery,
        page: page,
        size: PAGE_SIZE,
        refetchWhileRunning: isRunning,
    }), data = _h.data, isLoading = _h.isLoading;
    var severityOptions = useMemo(function () { return [
        {
            value: "ERROR",
            label: "".concat(formatMessage({
                id: "ui-br-agency.import.titleImport.section.errors",
            }), " (").concat(initialErrorCount, ")"),
        },
        {
            value: "WARNING",
            label: "".concat(formatMessage({
                id: "ui-br-agency.import.titleImport.section.warnings",
            }), " (").concat(initialWarningCount, ")"),
        },
    ]; }, [formatMessage, initialErrorCount, initialWarningCount]);
    var handleSeverityChange = function (e) {
        setSeverity(e.target.value);
        setOffset(0);
    };
    var handleApplyFilter = function () {
        setAppliedQuery(queryInput);
        setOffset(0);
    };
    var handleResetFilter = function () {
        setQueryInput("");
        setAppliedQuery("");
        setOffset(0);
    };
    var handleFilterKeyDown = function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
            handleApplyFilter();
        }
    };
    if (initialErrorCount === 0 && initialWarningCount === 0) {
        return null;
    }
    var items = (_b = data === null || data === void 0 ? void 0 : data.items) !== null && _b !== void 0 ? _b : [];
    var totalRecords = (_c = data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _c !== void 0 ? _c : 0;
    var columnHeaderLabel = severity === "ERROR"
        ? formatMessage({ id: "ui-br-agency.import.titleImport.table.error" })
        : formatMessage({ id: "ui-br-agency.import.titleImport.table.warning" });
    return (React.createElement("div", { className: styles.tableSection },
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.section.events" })),
        React.createElement("div", { className: styles.eventsFilterRow },
            React.createElement(Select, { dataOptions: severityOptions, value: severity, onChange: handleSeverityChange, "aria-label": formatMessage({
                    id: "ui-br-agency.import.titleImport.events.severity.aria",
                }) }),
            React.createElement(TextField, { value: queryInput, onChange: function (e) {
                    return setQueryInput(e.target.value);
                }, onKeyDown: handleFilterKeyDown, placeholder: formatMessage({
                    id: "ui-br-agency.import.titleImport.events.filter.placeholder",
                }), "aria-label": formatMessage({
                    id: "ui-br-agency.import.titleImport.events.filter.aria",
                }) }),
            React.createElement(Button, { onClick: handleApplyFilter },
                React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.events.filter.apply" })),
            appliedQuery && (React.createElement(Button, { buttonStyle: "default", onClick: handleResetFilter },
                React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.events.filter.reset" })))),
        React.createElement("div", { className: styles.eventsTotalRow },
            React.createElement(FormattedMessage, { id: "ui-br-agency.import.titleImport.events.total", values: { total: totalRecords } })),
        React.createElement(MultiColumnList, { contentData: items, loading: isLoading, visibleColumns: ["recordNumber", "controlNumber", "errorMessage"], columnMapping: {
                recordNumber: "#",
                controlNumber: formatMessage({
                    id: "ui-br-agency.import.titleImport.table.controlNumber",
                }),
                errorMessage: columnHeaderLabel,
            }, columnWidths: {
                recordNumber: "80px",
                controlNumber: "180px",
            }, pagingType: "prev-next", pagingOffset: offset, pageAmount: PAGE_SIZE, totalCount: totalRecords, onNeedMoreData: function (_amount, newOffset) {
                return setOffset(newOffset);
            } })));
};
